import { ModalHOC } from 'common';
import {
  ActionsButton,
  BasicModal,
  ChallengeInfoElem,
  DefaultButton,
  LoginCell,
  MoneyCell,
  Tooltip,
} from 'common/components';
import { CrossIcon, ReloadIcon } from 'common/icons';
import React, { useEffect, useState } from 'react';
import { FormattedMessage as FM } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';

import { getAccountTradeLink } from 'client/accounts/_redux';
import { staticStyles } from './style';

import { closeModal, openModal } from '../../../../interface/user/_redux/actions';
import OpenTradeLinkPanel from '../../../_components/OpenTradeLinkPanel';
import ChallengeProgress from './ChallengeProgress';
import { RestartChallengeForm } from '../../../challenges/_components';

const debounce = (func, delay) => {
  let timeoutId;
  return (...args) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
};

// FIXME: Пытался кастомны джсом но не мог зацепиться, пока так но убрать конечно все что связано с хиро в ближайшем будущем
const isHero =
  document.location.hostname === 'portal.herofx.co' || document.location.hostname === 'herodev.prod.uptr.dev';

const ChallengeItem = ({
  activeChallenge,
  archiveChallenge,
  getAccountTradeLink,
  noRedirect,
  showModal,
  history,
  modals,
  openModal,
  closeModal,
  userChallengesParams,
  onSuccess,
}) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [restartModalIsOpen, setRestartModalIsOpen] = useState(false);

  const updateWindowWidth = debounce(() => {
    setWindowWidth(window.innerWidth);
  }, 50);

  useEffect(() => {
    window.addEventListener('resize', updateWindowWidth);

    return () => {
      window.removeEventListener('resize', updateWindowWidth);
    };
  }, []);
  return (
    <div
      className="ChallengeAccountsItemWrapper"
      data-challenge-group={JSON.stringify(activeChallenge.challenge.group)}>
      <div className="ChallengeAccountsItem__Buttons ChallengeAccountsItem__Buttons--Mobile">
        <ActionsButton
          tooltipId="Restart__tooltip"
          tooltipTextId={isHero ? 'justRestartChallengeHero' : 'justRestartChallenge'}
          deleteType
          disabled={!activeChallenge.challenge.isAvailable}
          onClickFunc={() => {
            setRestartModalIsOpen(true);
          }}>
          <div className="ReloadIcon">
            <ReloadIcon />
          </div>
        </ActionsButton>
        <ActionsButton
          tooltipId="Delete__tooltip"
          tooltipTextId={isHero ? 'justArchiveChallengeHERO10X' : 'justArchiveChallenge'}
          deleteType
          onClickFunc={() => {
            showModal({
              modalClassName: 'challenge-modal',
              caption: { id: isHero ? 'justArchiveChallengeHERO10X' : 'justArchiveChallenge' },
              content: {
                id: isHero
                  ? 'justAreYouSureYouWantToArchiveThisChallengeHERO10X'
                  : 'justAreYouSureYouWantToArchiveThisChallenge',
              },
              actionButton: {
                textId: isHero ? 'justDelete' : 'justArchive',
                type: 'error',
                handler: () => archiveChallenge(activeChallenge.id),
              },
              cancelButton: null,
            });
          }}>
          <div className="CrossIconDiv">
            <CrossIcon />
          </div>
        </ActionsButton>
      </div>
      <button
        type="button"
        className="ChallengeAccountsItem"
        style={{ cursor: 'pointer' }}
        onClick={() => {
          if (noRedirect) {
            return;
          }

          history.push(`/challenges/${activeChallenge.id}`);
        }}>
        <LoginCell challenge title={activeChallenge.challenge.title} login={activeChallenge.account.login} />
      </button>
      <div className="ChallengeAccountsItem ChallengeAccountsItem--Right">
        <div className="ChallengeAccountsItem__Metrics">
          <div className="ChallengeAccountsItem__Metrics-Item">
            <FM id="justEquity">{text => <span>{text}:</span>}</FM>{' '}
            <MoneyCell style={{ fontWeight: 500 }} heightMaxContent value={activeChallenge.equity} />
          </div>
          <div className="ChallengeAccountsItem__Metrics-Item displayNoneHero">
            <FM id="justTotalProfit">{text => <span>{text}:</span>}</FM>
            <MoneyCell
              style={{ fontWeight: 500 }}
              success={+activeChallenge.totalProfit.amount >= 0}
              danger={+activeChallenge.totalProfit.amount < 0}
              heightMaxContent
              value={activeChallenge.totalProfit}
            />
          </div>
          <div className="ChallengeAccountsItem__Metrics-Item">
            <FM id="justDailyProfit">{text => <span>{text}:</span>}</FM>
            <MoneyCell
              style={{ fontWeight: 500 }}
              success={+activeChallenge.dailyProfit.amount >= 0}
              danger={+activeChallenge.dailyProfit.amount < 0}
              heightMaxContent
              value={activeChallenge.dailyProfit}
            />
          </div>
          {activeChallenge.totalProfit.amount < 0 && (
            <div className="ChallengeAccountsItem__Metrics-Item displayNoneHero">
              <FM id="justProfitTarget">{text => <span>{text}:</span>}</FM>
              <MoneyCell
                style={{ fontWeight: 500 }}
                danger
                heightMaxContent
                value={{ amount: `${activeChallenge.level.target}`, currency: activeChallenge.level.currency }}
              />
            </div>
          )}
        </div>
        <div className="ChallengeAccountsItem__Buttons ChallengeAccountsItem__Buttons--Desctop">
          <ActionsButton
            tooltipId="Restart__tooltip"
            tooltipTextId={isHero ? 'justRestartChallengeHERO10X' : 'justRestartChallenge'}
            deleteType
            disabled={!activeChallenge.challenge.isAvailable}
            onClickFunc={() => {
              setRestartModalIsOpen(true);
            }}>
            <div className="ReloadIcon">
              <ReloadIcon />
            </div>
          </ActionsButton>
          <ActionsButton
            tooltipId="Delete__tooltip"
            tooltipTextId={isHero ? 'justArchiveChallengeHERO10X' : 'justArchiveChallenge'}
            deleteType
            onClickFunc={() => {
              showModal({
                caption: { id: isHero ? 'justArchiveChallengeHERO10X' : 'justArchiveChallenge' },
                content: {
                  id: isHero
                    ? 'justAreYouSureYouWantToArchiveThisChallengeHERO10X'
                    : 'justAreYouSureYouWantToArchiveThisChallenge',
                },
                actionButton: {
                  textId: isHero ? 'justDelete' : 'justArchive',
                  type: 'error',
                  handler: () => archiveChallenge(activeChallenge.id),
                },
                cancelButton: null,
              });
            }}>
            <div className="CrossIconDiv">
              <CrossIcon />
            </div>
          </ActionsButton>
        </div>
      </div>
      <div className="ChallengeAccountsItem">
        <ChallengeInfoElem>{activeChallenge.title}</ChallengeInfoElem>
        <ChallengeInfoElem innerDotColor="blue">{activeChallenge.level.name}</ChallengeInfoElem>
        <ChallengeInfoElem borderColor="#0AA1E2">
          {activeChallenge.challenge?.initialAccountBalance && (
            <MoneyCell
              style={{ fontWeight: 500 }}
              heightMaxContent
              value={activeChallenge.challenge?.initialAccountBalance}
            />
          )}
        </ChallengeInfoElem>
      </div>

      <div
        className="ChallengeAccountsItem ChallengeAccountsItem--Right ChallengeAccountsItem__Chart"
        // style={{ scale: `${windowWidth < 450 ? `${(windowWidth / 450) * 100 - 15}%` : '100%'}` }}
      >
        <ChallengeProgress activeChallenge={activeChallenge} windowWidth={windowWidth} />
      </div>
      <div className="ChallengeAccountsItem ChallengeAccountsItem--EmptyCell" />
      <div className="ChallengeAccountsItem ChallengeAccountsItem--WebTerminalButton">
        {activeChallenge.account?.webTerminal && (
          <Tooltip
            id="clientTradeTooltip"
            textId={activeChallenge.account?.isBlocked ? 'clientTradeBlockedAccount' : ''}>
            <DefaultButton
              textId="clientTrade"
              filled
              onClick={() => {
                getAccountTradeLink({ accountId: activeChallenge.account.id });
                openModal('openTradeLink');
              }}
            />
          </Tooltip>
        )}
      </div>
      <BasicModal
        captionId="accountOpenTradeLink"
        isOpen={modals.openTradeLink}
        onRequestClose={() => closeModal('openTradeLink')}>
        {modals.openTradeLink && <OpenTradeLinkPanel onTradingStarted={() => closeModal('openTradeLink')} />}
      </BasicModal>

      <BasicModal
        captionId={isHero ? 'justRestartChallengeHERO10X' : 'justRestartChallenge'}
        isOpen={restartModalIsOpen}
        onRequestClose={() => setRestartModalIsOpen(false)}>
        <RestartChallengeForm
          challengeId={activeChallenge.challenge.id}
          challengeCost={activeChallenge.challenge.cost}
          restartButtonTextId={isHero ? 'justRestartChallengeHERO10X' : 'justRestartChallenge'}
          toggleModal={() => setRestartModalIsOpen(prev => !prev)}
          userChallengesParams={userChallengesParams}
          onSuccess={onSuccess}
        />
      </BasicModal>
      <style jsx>{staticStyles}</style>
    </div>
  );
};

export default compose(
  ModalHOC,
  withRouter,
  connect(
    state => ({
      modals: state.user.modals,
    }),
    {
      getAccountTradeLink: id => getAccountTradeLink.request(id),
      openModal: name => openModal(name),
      closeModal: name => closeModal(name),
    }
  )
)(ChallengeItem);
